import React from "react";
import Message from "../../i18n/Message";
import ModalDialog from "../shared/ModalDialog";
import Spinner from "../../assets/icons/Spinner";

const CancelSubscriptionDialog = ({ onConfirm, onCancel, date, loading = false }) => {
  return (
    <ModalDialog onClose={onCancel} closable={!loading}>
      <h1>
        <Message id="cancel_subscription_title" />
      </h1>
      <div className="cancel_confirm_text">
        <Message id="cancel_subscription_text" values={{ date }} />
      </div>
      <div className="buttons">
        <button
          className="btn bg-gradient-dark"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? <Spinner /> : <Message id="confirm_cancel" />}
        </button>
        <button className="btn no-btn" onClick={onCancel} disabled={loading}>
          <Message id="keep_plan" />
        </button>
      </div>
    </ModalDialog>
  );
};

export default CancelSubscriptionDialog;
